import { useCallback, useMemo } from "react";
import { useNavigate, useLocation } from "react-router";
import { stringify, parse } from "qs";

export const useQueryParam = (key: string) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const queryParams = useMemo(() => parse(search, { ignoreQueryPrefix: true }), [search]);

  const getQueryParam = useCallback(() => queryParams[key] as string | undefined, [key, queryParams]);
  const setQueryParam = useCallback(
    (value) => {
      navigate({
        pathname,
        search: stringify({ ...queryParams, [key]: value }),
      });
    },
    [key, navigate, pathname, queryParams]
  );
  const clearQueryParam = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [key]: _, ...rest } = queryParams;
    navigate(
      {
        pathname,
        search: stringify(rest),
      },
      { replace: true }
    );
  }, [key, navigate, pathname, queryParams]);

  return {
    getQueryParam,
    setQueryParam,
    clearQueryParam,
  };
};
